import { FleetState } from 'src/state/fleet-state'
import { UserState } from 'src/state/user-state'

export const user = (users: UserState) => (users ? users.currentUser : undefined)
export const getFleetId = (fleets: FleetState) =>
  fleets && fleets.selectedFleet ? fleets.selectedFleet.id : undefined
